module.exports = __webpack_public_path__ + "static/media/card-silver.292878df.png";